























import { ChevronRightIcon } from 'tdesign-icons-vue';
import { computed, defineComponent } from '@vue/composition-api';
import accountAssociationHandler from '@/renderer/views/desktop/ManageConsole/AccountAssociation/composition/accountAssociationHandler';
export default defineComponent({
  components: {
    ChevronRightIcon,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const store = context.root.$store;
    const { methods: associationMethods } = accountAssociationHandler();
    const methods = {
      choose(type: 'self' | 'delegate') {
        // 新用户点击代开发时需要提醒付费
        if (type === 'delegate' && !store.getters.allowWeworkSelfApp) {
          context.emit('choose-wework-type', type);
          methods.onClose();
        } else {
          context.emit('choose-wework-type', type);
          methods.onClose();
        }
      },
      onClose() {
        innerShow.value = false;
      },
    };
    return {
      innerShow,
      ...methods,
    };
  },
});
